(() => {
  document.querySelectorAll('[data-dobel-gift]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const modal = root.querySelector('[data-gift-modal]');
    const storageKey = `dobel-gift-${root.id}`;
    const couponCode = root.dataset.couponCode || '';
    const product = root.dataset.product || '';
    const productKey = root.dataset.productKey || '';
    const amazonUrl = root.dataset.amazonUrl || '';
    const rewardsEndpoint = root.dataset.rewardsEndpoint || '';
    const turnstileSiteKey = root.dataset.turnstileSiteKey || '';
    const turnstileContainer = root.querySelector('[data-turnstile-container]');
    let turnstileWidgetId = null;
    let turnstilePending = null;
    let turnstilePromise = null;
    let turnstileToken = '';
    const getSession = () => { try { return JSON.parse(sessionStorage.getItem(storageKey)) || {}; } catch (error) { return {}; } };
    const setSession = (value) => { try { sessionStorage.setItem(storageKey, JSON.stringify({ ...getSession(), product, productKey, ...value })); } catch (error) {} };
    const panel = (name, scroll = true) => { root.dataset.activeGiftPanel = name; root.querySelectorAll('[data-gift-panel]').forEach((item) => { item.hidden = item.dataset.giftPanel !== name; }); setSession({ currentPanel: name }); if (scroll) root.querySelector(`[data-gift-panel="${name}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    const setProgress = (active, complete = []) => root.querySelectorAll('[data-progress-step]').forEach((step) => { const name = step.dataset.progressStep; step.classList.toggle('is-active', name === active); step.classList.toggle('is-complete', complete.includes(name)); });
    const closeModal = () => { modal.hidden = true; document.body.classList.remove('dobel-gift-modal-open'); };
    const openModal = () => { modal.hidden = false; document.body.classList.add('dobel-gift-modal-open'); };
    const setSubmitting = (button, active, label) => { if (!button) return; if (active) { button.dataset.label = button.textContent.trim(); button.textContent = label; button.disabled = true; } else { button.textContent = button.dataset.label || button.textContent; button.disabled = false; } };
    const createJourneyId = () => {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      const bytes = window.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const value = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
    };
    const waitForTurnstile = () => new Promise((resolve, reject) => {
      if (window.turnstile) { resolve(window.turnstile); return; }
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (window.turnstile) { window.clearInterval(timer); resolve(window.turnstile); }
        else if (attempts >= 100) { window.clearInterval(timer); reject(new Error('verification_unavailable')); }
      }, 50);
    });
    const finishTurnstile = (method, value) => {
      const pending = turnstilePending;
      if (!pending) return;
      window.clearTimeout(pending.timeout);
      turnstilePending = null;
      turnstilePromise = null;
      if (turnstileContainer) turnstileContainer.hidden = true;
      if (method === 'resolve') turnstileToken = value;
      pending[method](value);
    };
    const getTurnstileToken = async (form) => {
      if (!turnstileSiteKey || !turnstileContainer) throw new Error('verification_not_configured');
      if (turnstileToken) return turnstileToken;
      if (turnstilePromise) return turnstilePromise;
      const turnstile = await waitForTurnstile();
      const submitButton = form?.querySelector('[type="submit"]');
      if (submitButton && turnstileContainer.parentElement !== form) form.insertBefore(turnstileContainer, submitButton);
      turnstileContainer.hidden = false;
      turnstilePromise = new Promise((resolve, reject) => {
        turnstilePending = {
          resolve,
          reject,
          timeout: window.setTimeout(() => finishTurnstile('reject', new Error('verification_timeout')), 90000),
        };
        try {
          const options = {
            sitekey: turnstileSiteKey,
            action: 'rewards_submission',
            appearance: 'interaction-only',
            callback: (token) => finishTurnstile('resolve', token),
            'error-callback': () => finishTurnstile('reject', new Error('verification_failed')),
            'expired-callback': () => { turnstileToken = ''; },
            'timeout-callback': () => finishTurnstile('reject', new Error('verification_timeout')),
          };
          if (turnstileWidgetId === null) turnstileWidgetId = turnstile.render(turnstileContainer, options);
          else turnstile.reset(turnstileWidgetId);
        } catch (error) {
          finishTurnstile('reject', error);
        }
      });
      return turnstilePromise;
    };    const submitReward = async (form, values) => {
      if (!rewardsEndpoint) throw new Error('rewards_not_configured');
      const current = getSession();
      const journeyId = current.journeyId || createJourneyId();
      if (!current.journeyId) setSession({ journeyId });
      const turnstileToken = await getTurnstileToken(form);
      const response = await fetch(rewardsEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          journeyId,
          productKey,
          rating: Number(current.rating),
          feedback: current.review || '',
          email: values.email ?? current.email ?? '',
          name: values.name ?? current.name ?? '',
          amazonChoice: values.amazonChoice ?? current.amazonChoice ?? '',
          amazonReviewName: values.amazonReviewName || '',
          amazonContactConsent: values.amazonContactConsent === true,
          status: values.status,
          sourcePage: `${window.location.origin}${window.location.pathname}`,
          turnstileToken,
        }),
      });
      let payload = {};
      try { payload = await response.json(); } catch (error) {}
      if (!response.ok || payload.ok !== true) throw new Error(payload.code || `http_${response.status}`);
      return payload;
    };
    const showCoupon = () => { const emailRewardNote = root.querySelector('[data-amazon-review-reward-note]'); if (emailRewardNote) emailRewardNote.hidden = !getSession().hasAmazonReviewDetails; panel('coupon'); setProgress('reward', ['review', 'email']); setSession({ currentPanel: 'coupon', finished: true }); };
    const configureAmazonLink = () => { const link = root.querySelector('[data-amazon-review-link]'); const missing = root.querySelector('[data-amazon-missing]'); link.href = amazonUrl || '#'; link.hidden = !amazonUrl; missing.hidden = Boolean(amazonUrl); };
    root.querySelector('[data-amazon-review-link]')?.addEventListener('click', () => { const returnButton = root.querySelector('[data-amazon-return]'); window.setTimeout(() => { if (returnButton) returnButton.hidden = false; }, 3000); });
    const setEnglishValidationMessages = (form) => form.querySelectorAll('input, textarea').forEach((field) => {
      field.addEventListener('input', () => field.setCustomValidity(''));
      field.addEventListener('invalid', () => {
        const { validity } = field;
        let message = 'Please complete this field correctly.';
        if (validity.valueMissing) message = 'Please fill out this field.';
        else if (validity.typeMismatch && field.type === 'email') message = 'Please enter a valid email address.';
        else if (validity.tooShort) message = `Please enter at least ${field.minLength} characters.`;
        else if (validity.tooLong) message = `Please use no more than ${field.maxLength} characters.`;
        field.setCustomValidity(message);
      });
    });
    root.querySelectorAll('form').forEach(setEnglishValidationMessages);
    const initializeScratchCard = () => {
      const canvas = root.querySelector('[data-scratch-canvas]'); const continueButton = root.querySelector('[data-scratch-continue]'); if (!canvas || !continueButton || canvas.dataset.ready === 'true') return; canvas.dataset.ready = 'true';
      const context = canvas.getContext('2d', { willReadFrequently: true }); const width = 840; const height = 420; let scratching = false; let complete = false; let lastCheck = 0; canvas.width = width; canvas.height = height;
      const gold = context.createLinearGradient(0, 0, width, height); gold.addColorStop(0, '#b98a28'); gold.addColorStop(.48, '#f0d478'); gold.addColorStop(1, '#9d711c'); context.fillStyle = gold; context.fillRect(0, 0, width, height); context.globalAlpha = .2;
      for (let index = 0; index < 120; index += 1) { context.fillStyle = index % 2 ? '#fff7cc' : '#715011'; context.beginPath(); context.arc(Math.random() * width, Math.random() * height, Math.random() * 3 + 1, 0, Math.PI * 2); context.fill(); }
      context.globalAlpha = 1; context.fillStyle = 'rgba(57,43,15,.72)'; context.font = '700 54px DM Sans,Arial,sans-serif'; context.textAlign = 'center'; context.textBaseline = 'middle'; context.fillText('SCRATCH HERE', width / 2, height / 2);
      const point = (event) => { const rect = canvas.getBoundingClientRect(); return { x: ((event.clientX - rect.left) / rect.width) * width, y: ((event.clientY - rect.top) / rect.height) * height }; };
      const check = () => { if (complete) return; const pixels = context.getImageData(0, 0, width, height).data; let transparent = 0; for (let index = 3; index < pixels.length; index += 32) if (pixels[index] < 40) transparent += 1; if (transparent / (pixels.length / 32) >= .3) { complete = true; continueButton.disabled = false; canvas.style.pointerEvents = 'none'; canvas.style.opacity = '0'; } };
      const scratch = (event) => { if (!scratching || complete) return; event.preventDefault(); const position = point(event); context.globalCompositeOperation = 'destination-out'; context.beginPath(); context.arc(position.x, position.y, 52, 0, Math.PI * 2); context.fill(); if (Date.now() - lastCheck > 140) { lastCheck = Date.now(); check(); } };
      canvas.addEventListener('pointerdown', (event) => { scratching = true; canvas.setPointerCapture(event.pointerId); scratch(event); }); canvas.addEventListener('pointermove', scratch); canvas.addEventListener('pointerup', () => { scratching = false; check(); }); canvas.addEventListener('pointercancel', () => { scratching = false; check(); });
      continueButton.addEventListener('click', () => { setSession({ started: true, currentPanel: 'review' }); closeModal(); panel('review', false); setProgress('review'); });
    };
    let saved = getSession(); if (saved.started && !saved.finished) { try { sessionStorage.removeItem(storageKey); } catch (error) {} saved = {}; }
    if (saved.started) { closeModal(); panel(saved.currentPanel || 'review', false); if (saved.email) root.querySelector('[data-email-form] [name="email"]').value = saved.email; if (saved.name) root.querySelector('[data-email-form] [name="name"]').value = saved.name; if (saved.email) root.querySelector('[data-details-email]').value = saved.email; if (saved.currentPanel === 'amazon-link') configureAmazonLink(); if (saved.currentPanel === 'coupon') { showCoupon(); } else if (saved.currentPanel === 'email' || saved.currentPanel === 'amazon-choice') setProgress('email', ['review']); else if (saved.currentPanel === 'review') setProgress('review'); else setProgress('reward', ['review', 'email']); } else { openModal(); initializeScratchCard(); }
    root.querySelector('[data-gift-close]')?.addEventListener('click', () => { if (window.Shopify?.designMode) closeModal(); else if (window.history.length > 1) window.history.back(); else window.location.assign('/'); });
    const reviewForm = root.querySelector('[data-review-form]');
    const continueToAmazonChoice = (rating, review) => {
      setSession({ rating, review, currentPanel: 'amazon-choice' });
      panel('amazon-choice');
      setProgress('email', ['review']);
    };
    reviewForm?.querySelectorAll('[name="rating"]').forEach((field) => field.addEventListener('change', () => {
      const error = reviewForm.querySelector('[data-rating-error]');
      error.hidden = true;
      error.textContent = '';
    }));
    reviewForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const reviewData = new FormData(form);
      const rating = Number(reviewData.get('rating'));
      const ratingError = form.querySelector('[data-rating-error]');
      if (!rating) {
        ratingError.textContent = 'Please select a rating.';
        ratingError.hidden = false;
        return;
      }
      ratingError.hidden = true;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (rating >= 4) {
        continueToAmazonChoice(rating, reviewData.get('review'));
        return;
      }
      const button = form.querySelector('button');
      setSubmitting(button, true, 'Saving...');
      try {
        setSession({ rating, review: reviewData.get('review'), currentPanel: 'email' });
        panel('email');
        getTurnstileToken(root.querySelector('[data-email-form]')).catch(() => {});
        setProgress('email', ['review']);
      } finally {
        setSubmitting(button, false);
      }
    });
    root.querySelector('[data-email-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const email = form.elements.email.value.trim();
      const name = form.elements.name.value.trim();
      const errorElement = form.querySelector('[data-email-error]');
      errorElement.hidden = true;
      errorElement.textContent = '';
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const button = form.querySelector('button');
      setSubmitting(button, true, 'Saving...');
      try {
        setSession({ email, name });
        await submitReward(form, { email, name, status: 'completed' });
        setSession({ email, name, currentPanel: 'coupon' });
        root.querySelector('[data-details-email]').value = email;
        showCoupon();
      } catch (error) {
        console.error('[Dobel Gift] Submission failed', error.message);
        errorElement.textContent = 'We could not save your details. Please try again.';
        errorElement.hidden = false;
      } finally {
        setSubmitting(button, false);
      }
    });
    root.querySelectorAll('[data-amazon-choice]').forEach((button) => button.addEventListener('click', async () => {
      const choice = button.dataset.amazonChoice;
      setSession({ amazonChoice: choice });
      if (choice === 'declined') {
        setSession({ amazonChoice: choice, currentPanel: 'email' });
        panel('email');
        getTurnstileToken(root.querySelector('[data-email-form]')).catch(() => {});
        setProgress('email', ['review']);
        return;
      }
      if (choice === 'willing') {
        configureAmazonLink();
        panel('amazon-link');
      } else {
        panel('amazon-details');
        getTurnstileToken(root.querySelector('[data-amazon-details-form]')).catch(() => {});
      }
    }));
    root.querySelector('[data-amazon-return]')?.addEventListener('click', () => { panel('amazon-details'); getTurnstileToken(root.querySelector('[data-amazon-details-form]')).catch(() => {}); });
    root.querySelector('[data-amazon-details-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const data = new FormData(form);
      const errorElement = root.querySelector('[data-amazon-details-error]');
      errorElement.hidden = true;
      errorElement.textContent = '';
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const email = data.get('email').trim();
      const name = data.get('name').trim();
      const amazonReviewName = data.get('amazon_name').trim();
      const button = form.querySelector('button');
      setSubmitting(button, true, 'Saving...');
      try {
        setSession({ email, name });
        await submitReward(form, { email, name, amazonReviewName, amazonContactConsent: true, status: 'amazon_details_completed' });
        setSession({ hasAmazonReviewDetails: true });
        showCoupon();
      } catch (error) {
        console.error('[Dobel Gift] Submission failed', error.message);
        errorElement.textContent = 'We could not save your details. Please try again.';
        errorElement.hidden = false;
      } finally {
        setSubmitting(button, false);
      }
    });
    root.querySelector('[data-copy-coupon]')?.addEventListener('click', async (event) => { try { await navigator.clipboard.writeText(couponCode); event.currentTarget.textContent = 'Copied'; } catch (error) { event.currentTarget.textContent = 'Select and copy'; } });
  });
})();
